// eslint-disable-next-line import/no-extraneous-dependencies, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TimelineContainer = styled.div({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.neutral', colors.N10),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&, & *': {
		boxSizing: 'border-box',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&::before, &&::after': {
		content: "' '",
		display: 'table',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&::after': {
		clear: 'both',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyHead = styled.div({
	float: 'left',
	width: '10%',
	minHeight: '92px',
	padding: `${token('space.050', '4px')} ${token('space.0', '0px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyContent = styled.div({
	float: 'right',
	position: 'relative',
	minHeight: '92px',
	width: '90%',
	paddingBottom: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RotationLabels = styled.ul({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&, &:first-of-type': {
		margin: `28px ${token('space.0', '0px')} ${token('space.0', '0px')}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		borderTop: `1px dashed ${token('color.border', colors.N40)}`,
	},
	padding: token('space.0', '0px'),
	listStyle: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > li': {
		height: '30px',
		padding: `${token('space.050', '4px')} ${token('space.075', '6px')} ${token(
			'space.025',
			'2px',
		)}`,
		font: token('font.body.UNSAFE_small'),
		lineHeight: '22px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		borderBottom: `1px dashed ${token('color.border', colors.N40)}`,
		marginTop: 'unset',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Marker = styled.div({
	height: '100%',
	width: '1px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.icon.accent.red', colors.R400),
	position: 'absolute',
	top: 0,
});
